import React from "react";

import { Icon } from "@perceptron/ui/components/icon";

import { useTapHandlers } from "@demo/hooks/useTapHandlers";

/**
 * Remove a single item from the media set.
 *
 * A dark disc in both themes, so the glyph stays white: `bg-foreground` alone
 * would invert in dark and lose it.
 */
export const MediaTileRemoveButton: React.FC<{
  index: number;
  testId: string;
  onRemove?: (event: React.MouseEvent | React.TouchEvent, index: number) => void;
}> = ({ index, testId, onRemove }) => {
  const tap = useTapHandlers((event) => onRemove?.(event, index));

  return (
    <button
      className="absolute right-2 top-2 z-50 flex size-8 cursor-pointer items-center justify-center rounded-full bg-foreground opacity-0 shadow-[0_2px_8px_rgba(0,0,0,0.35)] transition-opacity duration-150 hover:opacity-90 focus-visible:opacity-100 group-hover/tile:opacity-100 touch:opacity-100 dark:bg-background-alt-2"
      data-testid={testId}
      type="button"
      {...tap}
    >
      <Icon className="size-4 text-white" name="handle-remove" />
    </button>
  );
};
